(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
(() => {
  const handled = new WeakSet();
  const cache = new Map();
  const readPage = async (url, available) => {
    const key = url.toString();
    if (!cache.has(key)) {
      const pending = fetch(key, { signal: AbortSignal.timeout(12000) })
        .then(response => {
          if (!response.ok) throw new Error('Collection request failed');
          return response.text();
        })
        .then(html => {
          const document = new DOMParser().parseFromString(html, 'text/html');
          const grid = document.querySelector('#product-grid[data-hygge-stock-grid]');
          if (!grid) throw new Error('Collection grid missing');
          const items = Array.from(grid.children).filter(item => item.matches('li[data-hygge-available]'));
          if (available === 'true' && items.some(item => item.dataset.hyggeAvailable !== 'true')) {
            throw new Error('Availability filter not applied');
          }
          const total = Number(grid.dataset.hyggeTotal);
          if (!Number.isSafeInteger(total) || total < 0) throw new Error('Invalid collection count');
          if (total > 0 && items.length === 0) throw new Error('Empty parsed grid: ' + JSON.stringify({ tag: grid.tagName, children: grid.children.length, first: grid.firstElementChild?.outerHTML.slice(0, 250) }));
          return { items, total };
        });
      cache.set(key, pending);
      pending.catch(() => cache.delete(key));
      if (cache.size > 24) cache.delete(cache.keys().next().value);
    }
    return cache.get(key);
  };
  const orderGrid = async grid => {
    if (handled.has(grid)) return;
    handled.add(grid);
    const base = new URL(window.location.href);
    const availability = base.searchParams.get('filter.v.availability');
    if (availability === '0' || availability === '1') return;
    const size = Number(grid.dataset.hyggePageSize);
    const total = Number(grid.dataset.hyggeTotal);
    const currentPage = Number(grid.dataset.hyggePage);
    if (!size || !total || !currentPage || grid.tagName !== 'UL') return;
    base.searchParams.set('section_id', grid.dataset.id);
    const pageUrl = (available, page) => {
      const url = new URL(base);
      url.searchParams.set('filter.v.availability', available);
      url.searchParams.set('page', String(page));
      return url;
    };
    grid.setAttribute('aria-busy', 'true');
    try {
      const firstAvailable = await readPage(pageUrl('1', 1), 'true');
      const availableCount = firstAvailable.total;
      if (availableCount > total) throw new Error('Collection count mismatch');
      const start = (currentPage - 1) * size;
      const end = Math.min(start + size, total);
      const take = async (available, from, to) => {
        if (to <= from) return [];
        const firstPage = Math.floor(from / size) + 1;
        const lastPage = Math.floor((to - 1) / size) + 1;
        const pages = await Promise.all(Array.from({ length: lastPage - firstPage + 1 }, (_, index) =>
          readPage(pageUrl(available, firstPage + index), available === '1' ? 'true' : 'false')
        ));
        if (pages.some(page => page.total !== (available === '1' ? availableCount : total - availableCount))) {
          throw new Error('Collection availability changed');
        }
        const offset = from - (firstPage - 1) * size;
        return pages.flatMap(page => page.items).slice(offset, offset + to - from);
      };
      const takeSoldOut = async (from, to) => {
        if (to <= from) return [];
        const first = await readPage(pageUrl('0', 1), 'false');
        const items = first.items.filter(item => item.dataset.hyggeAvailable === 'false');
        const lastPage = Math.ceil(first.total / size);
        let page = 2;
        while (items.length < to && page <= lastPage) {
          const pages = Array.from({ length: Math.min(3, lastPage - page + 1) }, (_, index) => page + index);
          const results = await Promise.all(pages.map(number => readPage(pageUrl('0', number), 'false')));
          for (const result of results) {
            if (result.total !== first.total) throw new Error('Collection availability changed');
            items.push(...result.items.filter(item => item.dataset.hyggeAvailable === 'false'));
          }
          page += pages.length;
        }
        return items.slice(from, to);
      };
      const [inStock, soldOut] = await Promise.all([
        take('1', start, Math.min(end, availableCount)),
        takeSoldOut(Math.max(0, start - availableCount), Math.max(0, end - availableCount))
      ]);
      const items = [...inStock, ...soldOut];
      if (items.length !== end - start) throw new Error('Collection page incomplete: ' + JSON.stringify({ received: items.length, expected: end - start, availableCount, total, size, currentPage }));
      if (!grid.isConnected) return;
      const nodes = items.map(item => {
        const node = document.importNode(item, true);
        node.classList.remove('scroll-trigger', 'animate--slide-in', 'scroll-trigger--offscreen');
        return node;
      });
      grid.replaceChildren(...nodes);
      grid.dataset.hyggeStockSorted = 'true';
    } catch (error) {
      console.warn('Hyggestedet collection ordering:', error.message);
    } finally {
      grid.removeAttribute('aria-busy');
    }
  };
  const scan = () => document.querySelectorAll('#product-grid[data-hygge-stock-grid]').forEach(orderGrid);
  const start = () => {
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
    window.addEventListener('pageshow', scan);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
if (!customElements.get('hyggestedet-recommendations')) {
  customElements.define('hyggestedet-recommendations', class extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.track = this.querySelector('.hgr-track');
      this.prev = this.querySelector('[data-prev]');
      this.next = this.querySelector('[data-next]');
      const update = () => {
        this.prev.disabled = this.track.scrollLeft < 2;
        this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
      };
      const slide = direction => {
        const card = this.track.firstElementChild;
        if (card) this.track.scrollBy({left: direction * (card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap)), behavior:'smooth'});
      };
      this.prev.addEventListener('click', () => slide(-1));
      this.next.addEventListener('click', () => slide(1));
      this.track.addEventListener('scroll', update, {passive:true});
      this.resizeObserver = new ResizeObserver(update);
      this.resizeObserver.observe(this.track);
      this.loadProducts().then(update).catch(() => update());
    }
    disconnectedCallback() { this.resizeObserver?.disconnect(); }
    async loadProducts() {
      const cards = [];
      const ids = new Set();
      for (let page = 1; page <= 3 && cards.length < Number(this.dataset.limit); page++) {
        const url = new URL(this.dataset.url, location.origin);
        url.searchParams.set('section_id', 'related-products');
        url.searchParams.set('sort_by', 'best-selling');
        url.searchParams.set('page', page);
        const response = await fetch(url, {credentials:'same-origin'});
        if (!response.ok) throw new Error('Recommendations unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const template = doc.querySelector('template[data-hgr-cards]');
        if (!template) throw new Error('Recommendations missing');
        const pageCards = Array.from(template.content.querySelectorAll('.hgr-card'));
        for (const card of pageCards) {
          if (card.dataset.productId === this.dataset.current || ids.has(card.dataset.productId)) continue;
          ids.add(card.dataset.productId);
          cards.push(card);
        }
        if (!pageCards.length) break;
      }
      if (this.dataset.trending === 'true') {
        const priority = ['hyggeplaid-med-aermer-haette-lomme-200-x-150-cm','10-par-bambus-stroemper-i-sort-super-bloede-og-aandbare-stroemper','hjemmesko-blode-varme-luksuriose-brun-beige','himalaya-saltlampe-med-fod-1-2-kg','shiatsu-v2-varme-massagebaelte-til-nakke-og-skuldre','led-skabslampe-m-sensor-varm-hvid-200-lumen','ahh-bra-pakke-med-5-stk-bh','luksus-fod-og-laeg-massager-med-varme'];
        const rank = handle => {const index = priority.indexOf(handle); return index < 0 ? 999 : index;};
        cards.sort((a,b) => rank(a.dataset.handle) - rank(b.dataset.handle));
      }
      const prefix = this.getAttribute('aria-labelledby');
      for (const card of cards) {
        const mapping = new Map();
        card.querySelectorAll('[id]').forEach(element => {mapping.set(element.id, element.id + '-' + prefix); element.id += '-' + prefix;});
        card.querySelectorAll('[for],[aria-controls],[aria-labelledby],[href]').forEach(element => {
          for (const attr of ['for','aria-controls','aria-labelledby']) {
            if (element.hasAttribute(attr)) element.setAttribute(attr, element.getAttribute(attr).split(' ').map(id => mapping.get(id) || id).join(' '));
          }
          const href = element.getAttribute('href');
          if (href?.startsWith('#') && mapping.has(href.slice(1))) element.setAttribute('href','#' + mapping.get(href.slice(1)));
        });
        card.querySelectorAll('modal-opener[data-modal]').forEach(element => {const id = element.dataset.modal.slice(1);if (mapping.has(id)) element.dataset.modal = '#' + mapping.get(id);});
      }
      this.track.replaceChildren(...cards.slice(0, Number(this.dataset.limit)));
      this.hidden = cards.length === 0;
      this.dataset.loaded = 'true';
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
